export default __webpack_public_path__ + "static/media/quad@2x.13532588.png";